/* ========================================
   THE SQUAMISH HAT - THEME JS
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {

  /* ---- SCROLL ANIMATIONS ---- */
  var animateEls = document.querySelectorAll('.tsh-animate');
  if (animateEls.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.15 });
    animateEls.forEach(function(el) { observer.observe(el); });
  }

  /* ---- HEADER SCROLL (transparent → solid on homepage) ---- */
  var header = document.querySelector('.tsh-header--transparent');
  var mobileMenuEl = document.querySelector('.tsh-mobile-menu--transparent');
  if (header) {
    var scrollThreshold = 80;
    function updateHeader() {
      if (window.pageYOffset > scrollThreshold) {
        header.classList.add('tsh-header--scrolled');
      } else {
        header.classList.remove('tsh-header--scrolled');
      }
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ---- MOBILE MENU ---- */
  var toggle = document.querySelector('.tsh-header__mobile-toggle');
  var mobileMenu = document.querySelector('.tsh-mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      var icon = toggle.querySelector('svg');
      if (isOpen) {
        icon.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>';
      } else {
        icon.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      }
    });
    /* Close mobile menu when clicking a link */
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.classList.remove('is-open');
        var icon = toggle.querySelector('svg');
        icon.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
      });
    });
  }

  /* ---- PARALLAX HERO ---- */
  var heroImage = document.querySelector('.tsh-hero__image');
  if (heroImage) {
    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset;
      heroImage.style.transform = 'translateY(' + (scrollY * 0.4) + 'px)';
    }, { passive: true });
  }

  /* ---- TYPEWRITER EFFECT ---- */
  var typewriterEl = document.querySelector('[data-typewriter]');
  if (typewriterEl) {
    var text = typewriterEl.getAttribute('data-typewriter');
    var speed = parseInt(typewriterEl.getAttribute('data-typewriter-speed') || '80', 10);
    typewriterEl.textContent = '';
    typewriterEl.style.visibility = 'visible';
    var i = 0;
    function typeChar() {
      if (i < text.length) {
        typewriterEl.textContent += text.charAt(i);
        i++;
        setTimeout(typeChar, speed);
      }
    }
    setTimeout(typeChar, 500);
  }

  /* ---- PRODUCT VARIANT SELECTOR ---- */
  var variantSelects = document.querySelectorAll('.tsh-variant-select');
  var variantIdInput = document.querySelector('input[name="id"]');
  var addToCartBtn = document.querySelector('.tsh-product form button[type="submit"]');
  if (variantSelects.length > 0 && window.TSH_VARIANTS) {
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        var selectedOptions = [];
        variantSelects.forEach(function(s) { selectedOptions.push(s.value); });
        var match = window.TSH_VARIANTS.find(function(v) {
          return v.options.every(function(opt, idx) { return opt === selectedOptions[idx]; });
        });
        if (match && variantIdInput) {
          variantIdInput.value = match.id;
          if (addToCartBtn) {
            if (match.available) {
              addToCartBtn.textContent = 'Add to Cart';
              addToCartBtn.disabled = false;
            } else {
              addToCartBtn.textContent = 'Sold Out';
              addToCartBtn.disabled = true;
            }
          }
        }
      });
    });
  }

  /* ---- QUANTITY BUTTONS ---- */
  var qtyInput = document.getElementById('product-quantity');
  if (qtyInput) {
    var minusBtn = document.querySelector('[data-qty-minus]');
    var plusBtn = document.querySelector('[data-qty-plus]');
    if (minusBtn) {
      minusBtn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) {
          qtyInput.value = current - 1;
          qtyInput.dispatchEvent(new Event('change'));
        }
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
        qtyInput.dispatchEvent(new Event('change'));
      });
    }
  }

  /* ---- FRIENDS MODAL ---- */
  var friendsModal = document.getElementById('friends-modal');
  var friendsModalClose = document.getElementById('friends-modal-close');
  var openFriendsBtns = document.querySelectorAll('[data-open-friends-modal]');
  var friendsForm = document.getElementById('friends-signup-form');
  var friendsFormWrap = document.getElementById('friends-modal-form-wrap');
  var friendsSuccess = document.getElementById('friends-modal-success');
  var friendsError = document.getElementById('friends-form-error');

  function openFriendsModal() {
    if (friendsModal) {
      friendsModal.style.display = 'flex';
      friendsModal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Focus first input */
      var firstInput = friendsModal.querySelector('input:not([type="hidden"])');
      if (firstInput) setTimeout(function() { firstInput.focus(); }, 100);
    }
  }

  function closeFriendsModal() {
    if (friendsModal) {
      friendsModal.classList.remove('is-open');
      setTimeout(function() {
        friendsModal.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
  }

  openFriendsBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openFriendsModal();
    });
  });

  if (friendsModalClose) {
    friendsModalClose.addEventListener('click', closeFriendsModal);
  }

  if (friendsModal) {
    friendsModal.addEventListener('click', function(e) {
      if (e.target === friendsModal) closeFriendsModal();
    });
  }

  /* ---- FRIENDS FORM SUBMISSION ----
     Strategy:
       1. PRIMARY: POST to /contact with form_type=contact.
          This ALWAYS works on every Shopify store regardless of customer account settings.
          Shopify sends the store owner a notification email with the full message body.
          The body includes name, email, and instagram so the owner has everything they need.

       2. SECONDARY (best-effort): POST to /contact with form_type=customer.
          If customer accounts are enabled, this creates a customer record tagged
          "friends-of-tsh" and opted into email marketing — enabling Shopify Flow automations.
          If customer accounts are disabled, this silently fails, which is fine because
          step 1 already captured the data.
  */
  if (friendsForm) {
    friendsForm.addEventListener('submit', function(e) {
      e.preventDefault();

      /* Grab field references */
      var emailInput = friendsForm.querySelector('input[type="email"]');
      var nameInput = friendsForm.querySelector('input[name="contact[name]"]');
      var instagramInput = friendsForm.querySelector('input[name="contact[instagram]"]');
      var bodyInput = document.getElementById('friends-body');
      var consentCheckbox = document.getElementById('friends-consent');
      if (friendsError) friendsError.style.display = 'none';

      /* Validate */
      if (!nameInput || !nameInput.value.trim()) {
        if (friendsError) { friendsError.textContent = 'Please enter your first name.'; friendsError.style.display = 'block'; }
        if (nameInput) nameInput.focus();
        return;
      }
      if (!emailInput || !emailInput.value.trim() || !emailInput.validity.valid) {
        if (friendsError) { friendsError.textContent = 'Please enter a valid email address.'; friendsError.style.display = 'block'; }
        if (emailInput) emailInput.focus();
        return;
      }

      var submitBtn = friendsForm.querySelector('button[type="submit"]');
      if (submitBtn) { submitBtn.textContent = 'Joining\u2026'; submitBtn.disabled = true; }

      var firstName = nameInput.value.trim();
      var email = emailInput.value.trim();
      var instagram = instagramInput ? instagramInput.value.trim() : '';
      var acceptsMarketing = consentCheckbox ? consentCheckbox.checked : true;

      /* Populate the hidden body field with all details for the owner notification email */
      var bodyText =
        'New Friends of TSH signup\n' +
        '---\n' +
        'Name: ' + firstName + '\n' +
        'Email: ' + email + '\n' +
        'Instagram: ' + (instagram || 'not provided') + '\n' +
        'Accepts marketing: ' + (acceptsMarketing ? 'yes' : 'no');
      if (bodyInput) bodyInput.value = bodyText;

      /* Build FormData from the updated form (form_type=contact) */
      var formData = new FormData(friendsForm);

      /* Step 1: Contact form — guaranteed to work, sends owner notification email */
      fetch('/contact', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function() {

        /* Step 2: Log to Google Sheets — appends a row with name, email, instagram, date */
        fetch('https://script.google.com/macros/s/AKfycbwkvV-M-m4Glwsxv-iWpTEubwG6sBlCqWxbiX7YE1EcY4--fRnnwp066fLKBDwUR1MX_g/exec', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: firstName,
            email: email,
            instagram: instagram || '',
            accepts_marketing: acceptsMarketing ? 'yes' : 'no'
          }),
          mode: 'no-cors' /* Apps Script requires no-cors from cross-origin callers */
        }).catch(function() { /* silent — sheet logging is best-effort */ });

        /* Show success state */
        if (friendsFormWrap) friendsFormWrap.style.display = 'none';
        if (friendsSuccess) friendsSuccess.style.display = 'block';
      })
      .catch(function() {
        /* Network error fallback: submit the form normally so no data is lost */
        if (submitBtn) { submitBtn.textContent = 'Join the crew'; submitBtn.disabled = false; }
        friendsForm.submit();
      });
    });
  }

  /* ---- ESCAPE KEY CLOSES MODAL & MOBILE MENU ---- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (friendsModal && friendsModal.classList.contains('is-open')) {
        closeFriendsModal();
      }
      if (mobileMenu && mobileMenu.classList.contains('is-open')) {
        mobileMenu.classList.remove('is-open');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          mobileMenu.setAttribute('aria-hidden', 'true');
          var icon = toggle.querySelector('svg');
          icon.innerHTML = '<line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="18" x2="21" y2="18"></line>';
        }
      }
    }
  });

});
